// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#resident-group-register[data-v-5b08e59a]{max-width:740px;margin-left:auto;margin-right:auto}#resident-group-register .cancel-btn[data-v-5b08e59a],#resident-group-register .register-btn[data-v-5b08e59a]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
